import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import { statusTransitionQueryResponseType } from '@/modules/FileDetail/queries/statusTransition/statusTransitionQuery.type.ts';

export default (
  data: statusTransitionQueryResponseType,
): DetailCardItemData[] => [
  {
    type: 'default',
    keyName: 'اقدام',
    value: data?.case_status?.fa_const,
  },
  {
    type: 'default',
    keyName: 'کاربر',
    value: `${data.from_user?.first_name} ${data.from_user?.last_name}`,
  },
  {
    type: 'default',
    keyName: 'نقش',
    value: data?.action_user_role?.fa_const,
  },
];
